import * as React from "react";
import { getConvertHistoricalData } from "./convert";
import { processUTM } from "./utm";
import { userTrackingContext } from "../../providers/user-tracking/user-tracking-context";

function loadSession() {
  let user = window.localStorage.getItem("marketing-user");
  return JSON.parse(user);
}

function useUserTracking() {
  const userTracking = React.useContext(userTrackingContext);
  const [session, setSession] = React.useState();
  const [version, setVersion] = React.useState();

  const getUTM = () => {
    return processUTM({ session });
  };

  React.useEffect(() => {
    const updateStorage = () => {
      if (userTracking.isReady) {
        const s = loadSession();
        setSession(s.session);
        setVersion(s.version);
      }
    };
    updateStorage();

    window.addEventListener("storage", updateStorage);

    return () => {
      window.removeEventListener("storage", updateStorage);
    };
  }, [userTracking.isReady]);

  return {
    session,
    getConvertHistoricalData,
    getUTM,
    version,
  };
}

export default useUserTracking;
